import { Notice } from '../../../components/ui/notice.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { Can } from '../../acl/can.tsx';

type Props = {
    releasedDate?: string;
    className?: string;
};

export const IsReleasedBadge: React.FC<Props> = ({ releasedDate, className = '' }) => {
    const { t } = useLocale();

    if (releasedDate) {
        return null;
    }

    return (
        <Can do="read" on="QuoteOrder" field="released_date">
            <Notice
                variant="warning"
                className={className}
                title={t('badge__not_released_title', { ns: 'quotes-orders-line-items' })}
                description={
                    <Can I="release" a="QuoteOrder">
                        {t('badge__not_released_body', { ns: 'quotes-orders-line-items' })}
                    </Can>
                }
            />
        </Can>
    );
};
